import { Helmet } from 'react-helmet-async';

function SEO({ title, description }) {
  const pageTitle = title ? `${title} | Cyberautography` : 'Cyberautography';
  const pageDescription =
    description || 'Create a private or public autobiography profile with stories, prompts, widgets, and personal themes.';

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
    </Helmet>
  );
}

export default SEO;
